<template>
  <div :class="mainClass">
    <div style="padding: 40px 0;">
      <p class="clientOperateResult-p" v-if="!showInfo">{{ showLog ? "&nbsp;&nbsp;&nbsp;您已提交参会信息！" : "&nbsp;&nbsp;提交成功！" }}</p>
      <p class="clientOperateResult-p" v-else>填写信息</p>
    </div>
    <div style="" class='clentResultContent'>
      <template v-if='!showLog'>
        <div class="result-item">
          <p>姓名：{{ resultForm.name }}</p>
          <p>住宿安排：{{ resultForm.accomodation | accomodationFilter }}</p>
          <p>招待晚宴（3月27日周五）：{{ resultForm.dinner | dinnerFilter }}</p>
          <p style="border-bottom: 1px solid #e5e5e5;height: 18px"></p>
        </div>
        <div class="result-item">
          <p>接机/站安排：{{ resultForm.receive | receiveFilter }}</p>
          <template v-if="resultForm.receive === Receive01">
            <p>联系电话：{{ resultForm.receivePhone }}</p>
            <p>到达站点：{{ resultForm.receiveStation | stationFilter }}</p>
            <p v-if="resultForm.receiveStation !== Station04">航班号/车次：{{ resultForm.receiveNumber }}</p>
            <p v-if="resultForm.receiveStation !== Station04">到达时间：{{ resultForm.receiveTime | dateFilter }}</p>
            <p v-if="resultForm.receiveCompany">同行人：{{ resultForm.receiveCompany }}</p>
          </template>
          <p style="border-bottom: 1px solid #e5e5e5;height: 18px"></p>
        </div>
        <div class="result-item">
          <p>送机/站安排：{{ resultForm.send | receiveFilter }}</p>
          <template v-if="resultForm.send === Receive01">
            <p>联系电话：{{ resultForm.sendPhone }}</p>
            <p>出发站点：{{ resultForm.sendStation | stationFilter }}</p>
            <p v-if="resultForm.sendStation !== Station04">酒店出发时间：{{ resultForm.sendTime | dateFilter }}</p>
          </template>
        </div>
      </template>
      <div class="clientResultBtnGroup">
        <template v-if="!showInfo">
          <template v-if="showLog">
            <van-button type="default" @click="toClientOperateResult" style="margin-top: 20px;">修改已填信息</van-button>
            <van-button type="default" @click="toMeetingStep" style="margin-top: 20px;">查看会议议程</van-button>
            <van-button type="default" @click="toClientLogin" style="margin-top: 20px;">继续新增参会人员</van-button>
          </template>

          <template v-else>
            <van-button type="default" @click="toMeetingStep" style="margin-top: 20px;">查看会议议程</van-button>
            <van-button type="default" @click="toClientOperateResult" style="margin-top: 20px;">修改已填信息</van-button>
            <van-button type="default" @click="toClientLogin" style="margin-top: 20px;">继续新增参会人员</van-button>
          </template>
        </template>
        <van-button type="default" @click="completeInvitation" class='closeResultBtn'>关闭</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {queryResult} from '@/service/invitationClientApis'
import {dateFormat} from "@/util/common";
import {AccomodationMap, DinnerMap, StationMap, Receive01, Station04,ReceiveMap,} from "@/util/constants";
import {Shares} from '@/util/Share'

export default {
  name: "clientResult",
  data() {
    return {
      resultForm: {
        name: "",
        accomodation: '',
        dinner: "",
        receive: "",
        receivePhone: "",
        receiveStation: "",
        receiveNumber: "",
        receiveTime: '',
        receiveCompany: "",
        send: "",
        sendPhone: "",
        sendStation: "",
        sendTime: "",
      },
      showLog: "",
      Receive01,
      Station04
    }
  },
  computed: {
    showInfo() {
      return this.$route.query.showInfo
    },
    clientId() {
      return this.$store.state.base.clientId
    },
    mainClass() {
      return !!this.showLog ? "clientResult defatult-bg clientResultLog" : "clientResult defatult-bg"
    }
  },
  methods: {
    toClientOperateResult() {
      this.$router.push({name: "clientOperateResult2024"})
    },
    toMeetingStep() {
      this.$router.push({name: "meetingStep2024", query: {noBth: "1"}})
    },
    toClientLogin() {
      this.$store.commit("setClientId", "")
      this.$router.push({name: "clientLogin2024"})
    },
    completeInvitation() {
      this.$router.push({name: "refuseInvitation2024", query: {status: '1'}})
    }
  },
  filters: {
    accomodationFilter(val) {
      return !val && !AccomodationMap[val] ? "" : (AccomodationMap[val] || val)
    },
    dinnerFilter(val) {
      return !val && !DinnerMap[val] ? "" : (DinnerMap[val] || val)
    },
    receiveFilter(val) {
      return !val && !ReceiveMap[val] ? "" : (ReceiveMap[val] || val)
    },
    stationFilter(val) {
      return !val && !StationMap[val] ? "" : (StationMap[val] || val)
    },
    dateFilter(val) {
      if (!val) {
        return ""
      } else {
        return dateFormat(new Date(val), 'YYYY年MM月DD日 HH:mm')
      }
    }
  },
  async mounted() {
    Shares.shareCode()
    if(this.clientId) {
      let {showLog} = this.$route.query
      this.showLog = showLog || ""
      let historyDataRes = await queryResult({clientId: this.clientId})
      if (historyDataRes) {
        let {code, msg} = historyDataRes
        if (code === '0') {
          for (let key in this.resultForm) {
            this.resultForm[key] = historyDataRes[key]
          }
          console.log("合并历史记录的数据", this.resultForm, historyDataRes)
        } else {
          this.$message.error(msg || '服务异常，请联系客服');
        }
      }
    } else {
      this.$router.push({name: 'clientLogin2024'})
    }

  }
}
</script>

<style lang="less">
.clientResult {
  height: 100vh !important;
  overflow: auto;
  box-sizing: border-box;
  padding: 0 16px;
  padding-bottom: 48px;

  p {
    margin: 0;
    //padding: 8px 16px;
  }

  .clentResultContent {
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    height: auto
  }

  .clientOperateResult-p {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    //background: #fff;
    // height: 12vh;
    // line-height: 12vh;
    margin: 0;
    color: #fff;
  }

  .result-item {
    margin-top: 14px;
    background-color: #fff;
    padding: 0 16px;

    > p {
      line-height: 32px;
      //height: 24px;
      font-size: 18px;
      word-break: break-all;
    }
  }

  .clientResultBtnGroup {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > button {
      margin-top: 5px;
      width: 80%;
      font-size: 18px;
      height: 48px;
      line-height: 48px;
      background-color: #134CDB;
      font-weight: 550;
      border: 0;
      color: #fff;
      //font-weight: bold;
    }

    .closeResultBtn {
      margin-top: 35px;
      background-color: #DADADA;
      margin-bottom: 50px;
      color: #808080;
    }
  }
}

.clientResultLog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;

  > div,
  > p {
    width: 100%;
  }

  .clientOperateResult-p {
    // height: 48px;
    // line-height: 48px;
    // margin: 30px 0;
  }

  .clentResultContent {
    background: transparent;
  }

  .clientResultBtnGroup {
    > button {
      background-color: #fff;
      color: #000;
    }

    .closeResultBtn {
      margin-top: 70px;
    }
  }
}
</style>
